import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/slices/authSlice";
import Layout from "../components/Layout/Layout";
import { Box, Button, Grid, SvgIcon, Typography } from "@mui/material";
import refresh from "../assets/refresh.svg";
import grn_calendarIco from "../assets/grn_calendarIco.svg";
import "../css/dashboard.css";
import PopupModal from "../components/Modal/PopupModal";
import clock from "../assets/clock_ico.svg";
import Periodic from "../components/Periodic/Periodic";
import Alert from "@mui/material/Alert";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import LayoutBanner from "../components/Layout/LayoutBanner";
import BTable from "../components/Table/Table";
import { TablePagination } from "../components/Pagination/TablePagination";
import banner from "../assets/banner_dashboard.svg";
import addStud from "../assets/add_stud.svg";
import syncStud from "../assets/sync_stud.svg";
import updateStud from "../assets/updated_stud.svg";
import {
  onDemandUpdate,
  getCount,
  getSchedule,
  reset,
} from "../redux/slices/scheduleSlice";
import { formatDateandTime, formatDateandTime1 } from "../utils/helper";
import Loader from "../components/Loader/Loader";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import api from "../Api";

dayjs.extend(utc);
dayjs.extend(timezone);

const Dashboard = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [passwordNotify, setPasswordNotify] = useState(false);
  const [demandUpdate, setDemandUpdate] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [type, setType] = useState("");
  const [converted, setConverted] = useState([]);
  const scheduleState = useSelector((state) => state.schedule);
  const authState = useSelector((state) => state.auth.data);

  useEffect(() => {
    setOpenAlert(scheduleState.isUpdated);
    setTimeout(() => {
      setOpenAlert(false);
      dispatch(reset());
    }, 3000);
  }, [scheduleState.isUpdated]);
  useEffect(() => {
    if (authState?.access_token !== "") {
      api.defaults.headers.common.Authorization = authState?.access_token
        ? `Bearer ${authState?.access_token}`
        : "";
      dispatch(getSchedule(page));
      dispatch(getCount());
    }
  }, [dispatch, authState?.access_token]);

  const handleSubmit = (data) => {
    console.log(data, "HELLO", type);
  };
  const handleClose = () => {
    setOpen(false);
  };

  function formatNumber(number) {
    if (number === 0) {
      return "0";
    }
    return String(number).padStart(2, "0");
  }

  const ScheduleList = (scheduleState, page, pageSize = 10) => {
    const systemTimezone = dayjs.tz.guess();
    const startIndex = (page - 1) * pageSize;
    console.log(systemTimezone,'>>>>')
    // Check if scheduleState.data.rows is an array
    if (!Array.isArray(scheduleState?.data?.rows)) {
      return []; // or handle this case appropriately
    }
  
    const paginatedRecords = scheduleState.data.rows.map((item, index) => ({
      ...item,
      s_id: startIndex + index + 1,
    }));
  
    return paginatedRecords.map((schedule) => {
      const scheduledFrom = dayjs(schedule?.scheduled_from).tz(systemTimezone);
      const scheduledTo = dayjs(schedule?.scheduled_to).tz(systemTimezone);
      const createdAt = dayjs(schedule?.createdAt).tz(systemTimezone);
       return {
        ...schedule,
        scheduleDateTime: `${scheduledFrom.format("MM/DD/YYYY @ hh:mm a")} to ${scheduledTo.format("MM/DD/YYYY @ hh:mm a")}`,
        createdAt: createdAt.format("MM/DD/YYYY @ hh:mm a"),
      };
    });
  };

  const dateConvert = (date) => {
    const date1 = new Date(date);
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = date1
      .toLocaleString("en-US", options)
      .replace(",", "");

    return formattedDate.replace(" ", " @ ");
  };

  const dateConvert1 = (date) => {
    const date1 = new Date(date);
    const options = {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    };
    const formattedDate = date1
      .toLocaleString("en-US", options)
      .replace(",", "");
    return formattedDate.replace(" ", " @ ");
  };

  useEffect(() => {
    let schedule = ScheduleList(scheduleState, page, 10);
     // scheduleState?.data?.rows?.map((schedule) => ({
    //   ...schedule,
    //   scheduleDateTime: dateConvert(schedule?.scheduled_from) + " to " + dateConvert(schedule?.scheduled_to),
    //     // dayjs(schedule?.scheduled_from).locale("en-US").format("MM/DD/YYYY"+" @ "+"hh:MM a") +
    //     // " to " +
    //     // dayjs(schedule?.scheduled_to).format("MM/DD/YYYY"+" @ "+"hh:MM a"),
    //   createdAt: dateConvert1(schedule?.createdAt)//dayjs(schedule?.createdAt).format("MM/DD/YYYY"+" @ "+"hh:MM a"),
    // }))
    //   scheduleState?.data?.rows?.map((schedule) => ({

    //     ...schedule,
    //     scheduleDateTime:
    //         dayjs(schedule?.scheduled_from).format("MM/DD/YYYY @ hh:mm a") +
    //         " to " +
    //         dayjs(schedule?.scheduled_to).format("MM/DD/YYYY @ hh:mm a"),
    //     createdAt:
    //         dayjs(schedule?.createdAt).format("MM/DD/YYYY @ hh:mm a"),
    // }))
    setConverted(schedule);
  }, [scheduleState?.data?.rows]);

  // useEffect(()=>{
  //   setPasswordNotify(true)
  // },[])

  const handlePageChange = (v) => {
    dispatch(getSchedule(v));
    setPage(v);
  };
  return (
    <Layout>
      <LayoutBanner
        title={"Build Smart Tool"}
        body={
          "This integration tool facilitates seamless synchronization of data between Classe365, a comprehensive Student Management System (SMS), and SkyPrep, a Learning Management System (LMS). The integration enables the exchange and updating of student data, enrollment records, and progress tracking between the two platforms, ensuring consistency and accuracy across systems."
        }
        image={banner}
      />
      <Loader message={"Loading"} show={scheduleState.isLoading && !open} />
      <Grid container spacing={2} mb={3} className="dash">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Typography className="heading">Dashboard</Typography>
          <>
            {openAlert && (
              <Alert
                icon={
                  <CheckCircleOutlineIcon
                    fontSize="inherit"
                    sx={{ color: "#fff" }}
                  />
                }
                sx={{
                  padding: "0 2%",
                  background: "rgb(83, 179, 136)",
                  color: "#fff",
                  alignItems: "center",
                }}
              >
                Synced Successfully
              </Alert>
            )}
          </>
        </Grid>
        <Grid item md={12}>
          <Box component="div" className="card" p={"10px 20px"}>
            <Box
              component="div"
              borderBottom={"1px solid #dfeaf2"}
              py={2}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              flexWrap={"wrap"}
            >
              <Typography fontSize={16} width={{ md: "30%" }}>
                Keep your data updated
              </Typography>
              <Box
                component={"div"}
                display={"flex"}
                width={{ md: "60%" }}
                justifyContent={"end"}
              >
                <Button
                  variant="contained"
                  className="dash_btn btn-blue"
                  onClick={() => {
                    setOpen(true);
                    setType("schedule");
                  }}
                >
                  <img src={clock} alt="icon" />
                  Setup a schedule update
                </Button>
                <Button
                  variant="contained"
                  className="dash_btn btn-red"
                  onClick={() => {
                    setDemandUpdate(true)
                  }}
                >
                  <img src={refresh} alt="refresh" /> On-Demand Update
                </Button>
              </Box>
            </Box>
            <Box
              component={"div"}
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Box
                component={"div"}
                className="card-sm"
                p={2}
                bgcolor={"#f2f5fe"}
              >
                <Box
                  component={"div"}
                  display="flex"
                  justifyContent="space-between"
                  alignItems={"center"}
                >
                  <Typography fontSize={16} variant="h6" fontWeight={400}>
                    Synced Students
                  </Typography>
                  <img src={syncStud} />
                </Box>
                <Typography fontSize={32} variant="h6" fontWeight={600}>
                  {scheduleState?.count?.totalCount
                    ? formatNumber(scheduleState?.count?.totalCount)
                    : "00"}
                </Typography>
              </Box>
              <Box
                component={"div"}
                className="card-sm"
                p={2}
                bgcolor={"#fdf2f3"}
              >
                <Box
                  component={"div"}
                  display="flex"
                  justifyContent="space-between"
                  alignItems={"center"}
                >
                  <Typography fontSize={16} variant="h6" fontWeight={400}>
                    Students Added
                  </Typography>
                  <img src={addStud} />
                </Box>
                <Typography fontSize={32} variant="h6" fontWeight={600}>
                  {scheduleState?.count?.addedCount
                    ? formatNumber(scheduleState?.count?.addedCount)
                    : "00"}
                </Typography>
              </Box>
              <Box
                component={"div"}
                className="card-sm"
                p={2}
                bgcolor={"#fef8ec"}
              >
                <Box
                  component={"div"}
                  display="flex"
                  justifyContent="space-between"
                  alignItems={"center"}
                >
                  <Typography fontSize={16} variant="h6" fontWeight={400}>
                    Students Updated
                  </Typography>
                  <img src={updateStud} />
                </Box>
                <Typography fontSize={32} variant="h6" fontWeight={600}>
                  {scheduleState?.count?.updatedCount
                    ? formatNumber(scheduleState?.count?.updatedCount)
                    : "00"}
                </Typography>
              </Box>
              <Box
                component={"div"}
                className="card-sm"
                p={2}
                bgcolor={"#eefbf4"}
              >
                <Box
                  component={"div"}
                  display="flex"
                  justifyContent="space-between"
                  alignItems={"center"}
                >
                  <Typography fontSize={16} variant="h6" fontWeight={400}>
                    Last Synced Date/Time
                  </Typography>
                  <img src={grn_calendarIco} />
                </Box>
                <Box
                  component={"div"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  mt={1}
                >
                  <Typography fontSize={20} variant="h6" fontWeight={500}>
                    {scheduleState?.count?.createdAt
                      ? formatDateandTime(scheduleState.count.createdAt).date
                      : "--"}
                  </Typography>
                  <span className="vertical-line"></span>
                  <Typography
                    fontSize={20}
                    textAlign={"center"}
                    variant="h6"
                    fontWeight={500}
                  >
                    {scheduleState?.count?.createdAt
                      ? formatDateandTime(scheduleState.count.createdAt).time
                      : "--"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2} className="dash">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          display={"flex"}
          justifyContent={"space-between"}
        >
          <Typography className="heading">Scheduled List</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <BTable
            rows={[
              { name: "S.No", field: "s_id" },
              { name: "Scheduled By", field: "scheduled_by" },
              { name: "Scheduled Date&Time", field: "scheduleDateTime" },
              { name: "Status", field: "status" },
              { name: "Created Time", field: "createdAt" },
              { name: "Students Added", field: "totalAdded" },
              { name: "Students Updated", field: "totalUpdated" },
            ]}
            data={converted}
            cellStyles={{
              completed: { color: "#499E27" },
              scheduled: { color: "rgb(252 181 70)" },
            }}
          />
          <Box variant="div" display={"flex"} my={2} justifyContent={"end"}>
            <TablePagination
              totalPages={scheduleState?.data?.count || 0}
              page={page}
              handlePageChange={handlePageChange}
            />
          </Box>
        </Grid>
      </Grid>

      <PopupModal
        card_width={550}
        open={open}
        handleClose={() => setOpen(false)} 
        content={
          <>
            <Periodic
              handleSubmit={handleSubmit}
              handleClose={handleClose}
              type={type}
            />
          </>
        }
      />
      <PopupModal
       card_width={500}
        open={passwordNotify}
        content={
          <Box component={"div"} p={3}>
            <Typography
              color={"#EB4415"}
              fontSize={20}
              fontWeight={700}
              textAlign={"center"}
            >
              Change Password
            </Typography>
            <Typography
              fontSize={16}
              textAlign={"center"}
              fontWeight={400}
              variant="h6"
              my={3}
            >
              You can change the password in the edit profile menu.
            </Typography>
            <Button
              variant="contained"
              onClick={() => setPasswordNotify(false)}
              sx={{
                background: "#358AD4",
                fontSize: "16px",
                padding: "3% 12%",
                margin: "0 auto",
                display: "block",
              }}
            >
              Ok
            </Button>
          </Box>
        }
      />
      <PopupModal
        card_width={500}
        open={demandUpdate}
        content={
          <Box component={"div"} p={3}>
            <Typography
              color={"#CF1E21"}
              fontSize={"20px"}
              fontWeight={700}
              textAlign={"center"}
            >
              On Demand Update?
            </Typography>
            <Typography
             fontSize={"16px"}
              textAlign={"center"}
              fontWeight={500}
              variant="h6"
              my={3}
            >
              Would  you like to perform a complete sync now?
            </Typography>
            <Box variant={'div'}  sx={{display: 'flex', justifyContent: 'center', width: '100%'}}>
            <Button
              variant="contained"
              onClick={() => setDemandUpdate(false)}
              sx={{
                background: "#777777",
                '&:hover':{
                  background: "#777777"
                },
                fontSize: "16px",
                 display: "block",
                padding:"10px",
                width:"25%",textAlign:"center",
                marginRight:"20px"
              }}
              size="small"
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={() => {dispatch(onDemandUpdate());setDemandUpdate(false)}}
              sx={{
                background: "#CF1E21",
                '&:hover':{
                  background: "#CF1E21"
                },
                fontSize: "16px",
                 textAlign:"center",
                padding:"10px",
                display: "block", width:"25%"
              }}
            >
              Yes
            </Button>
            </Box>
          </Box>
        }
      />
    </Layout>
  );
};

export default Dashboard;
